import { DataTable } from './../../interfaces/datatable.interface';
import { CollapseData } from './../datatable-table/interfaces/collapse-data.interface';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-datatable-cell-collapse',
  templateUrl: './datatable-cell-collapse.component.html',
  styleUrls: ['./datatable-cell-collapse.component.scss']
})
export class DatatableCellCollapseComponent implements OnInit {

  @Input() datatable: DataTable;
  @Input() collapseData: CollapseData[] = [];
  @Input() i: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

  toggleCollapseData(index) {
    if (this.collapseData[index].canCollapse) {
      this.collapseData[index].open = !this.collapseData[index].open;
      this.datatable.hooks.onCollapseData(this.collapseData);
    }
  }

}
